<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="success" icon="el-icon-document-checked" @click="tempDownload">
              엑셀
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="10">
              <el-form-item label="설치요청일자" label-width="100px">
                <el-row>
                  <el-col>
                    <el-col :span="11">
                      <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="12">
                      <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="진행상태" label-width="100px">
                <el-select v-model="form.status">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['setupStatus']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리기사" label-width="100px">
                <el-select v-model="form.userId" >
                  <el-option value='0' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['agentUser']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :enableRangeSelection="true"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @cell-clicked="onCellClicked"
                @grid-ready="onReadyMain" />
            <ag-grid-vue
                ref="gridTemp"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnTemp"
                :grid-options="tempGridOptions"
                :row-data="data"
                :default-col-def="defaultColTemp"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                v-show="false"
            />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import lucoms from '@/mixin/lucoms';

import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import InstallTreat from "@/components/AS/InstallList/InstallTreat";

function _phone(hp){
  return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [lucoms],
  props: {
  },
  component: InstallTreat,
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        startDt: this.$moment().subtract(7, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        // endDt:  '',
        status: '',
        userId: '0',
        sortType : '',           // 승인/정산처리유형
        siteNm1 : '',            // 사이트명1
        siteNm2 : '',            // 사이트명2
        siteNm3 : '',            // 사이트명3
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'maType' : [],
        'catId' : [],
        'subCatId' : [],
        'siteType' : []
      },
      changeCatIdShow : false,
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 10px; width: 100%;height: 77vh; min-height:100px;',
      defaultColDef: {
        resizable: true
        , filter:false
        , sortable: true
      },
      defaultColTemp: {
        resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      tempGridApi: null,
      tempColumnApi: null,
      tempGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      columnDefs: [],
      columnTemp: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      productInstallEditDetail: []
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      const vm = this
      this.columnDefs = [
        {headerName:'설치완료요청일', field:'requestSetupDt', width:110, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            params.value = params.value === null  ? '' : vm.getDateFormat(`${params.value}`) ;
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }
        },
        {headerName:'설치기사', field:'userNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNms', width:160,
          valueGetter: (params) => {
            return params.data.siteNm1 + ' ' + params.data.siteNm2 + ' ' + params.data.siteNm3
          }},
        {headerName:'고객명', field:'chargeNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'전화번호', field:'telNo', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'주소', field:'addrs', width:160,
          valueGetter: (params) => {
            return params.data.addr1 + ' ' + params.data.addr2
          }},
        {headerName:'모델', field:'setupModelNm', width:160},
        {headerName:'수량', field:'setupModelQty', width:140},
        {headerName:'작업내용', field:'memo', width:140},
        {headerName:'진행상태', field:'setupStatus', width:140,
          valueFormatter: (params) => {
            return vm.chkType(params.value);
          }},
        {headerName:'의뢰자', field:'requestNm', width:140},
        {headerName:'', field:'requestId', hide : true}
      ];

      this.columnTemp = [
        {headerName:'설치요청일', field:'requestSetupDt', width:110, cellStyle:{textAlign: 'center'},},
        {headerName:'처리기사', field:'userNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트명', field:'siteNm', width:200},
        {headerName:'고객명', field:'chargeNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'전화번호', field:'telNo', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'주소', field:'addr', width:200},
        {headerName:'모델', field:'setupModelNm', width:160},
        {headerName:'수량', field:'setupModelQty', width:140},
        {headerName:'작업내용', field:'memo', width:140},
        {headerName:'진행상태', field:'setupStatus', width:140},
        {headerName:'의뢰자', field:'requestNm', width:140}
      ];
    },
    tempDownload(){
      this.tempGridOptions.api.exportDataAsExcel({fileName: '설치 처리리스트'});
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')
      if(this.isEmpty(this.form.endDt) == '') this.form.endDt = '';
      const vForm = {
        companyId : this.form.companyId,
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        asAgentId : this.$store.state.loginInfo.asAgentId,
        userId : this.form.userId,
        status : this.form.status,
        sortType : this.form.sortType,          // 승인/정산처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/agent/InstallAgnet/list"), vForm)
          .then(response => {
            this.data = response.data;

            // 엑셀 저장용으로 가공
            response.data.forEach(x=>{
              x.requestSetupDt = x.requestSetupDt !==null ? this.$moment(x.requestSetupDt).format('YYYY-MM-DD') : '';
              x.siteNm = x.siteNm1 + ' ' + x.siteNm2 + ' ' + x.siteNm3;
              x.addr = x.addr1 + ' ' + x.addr2;
              x.setupStatus = this.chkType(x.setupStatus);
              x.telNo = _phone(x.telNo);
            })
            this.tempData = response.data;
          }).finally(() => {
        this.$store.commit('finish')
        // this.autoSizeAll(this.mainGridApi);
      });
    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/agent/InstallAgnet/init`)
          .then(response => {
            this.combos['setupStatus'] = response.data.setupStatus;
            this.combos['agentUser'] = response.data.agentUser;
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    chkType(params) {
      this.combos['setupStatus'].forEach(x =>{
        if(params === x.key) params = x.value;
      })
      return params;
    },
    getNumberFormat(val) {
      if(val){

        if(typeof val === "string"){
          val = val.replace(/,/g, "")
        }
        return val;
        // return Math.floor(val).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    onCellClicked(params) {
      //const idx = params.rowIndex;
      const field = params.colDef.field;
      if(field === 'requestSetupDt') {
        const vForm = {
          companyId : this.form.companyId,
          requestId: params.data.requestId,
          asAgentId : this.$store.state.loginInfo.asAgentId,
          processTime : ''
        }
        this.$http.post(_url("/api/agent/InstallAgnet/detail/item"), vForm)
            .then(response => {
              // this.bsMaEditDetail = response.data;
              this.openModel(response.data);
              //this.bsMaEditDetail.data = response.data.uvwBsMaItemD
              // this.bsMaEditDetail.uvwBsMaItemM[0].siteTypeCombo = this.combos['siteType']
            }).finally(() => {
          this.$store.commit('finish')
        });
        // this.openModel(params.data);
      }
    },
    openModel(param) {
      console.log(param);
      let vm = this;
      this.$modal.open({
        width: 800,
        component: InstallTreat,
        parent: this,
        props: {
          data: param
        },
        events: {
          close(data) {
            console.log('close', data);
          },
          goOpen(){
            vm.goOpen();
          }
        }
      });
    },
  },
  created() {

    if(this.$route.query.startDt == 'TodayComplete'){
      this.form.startDt = this.$moment().format('YYYY-MM-DD');
    }else if(this.$route.query.startDt == 'TodayWork'){
      this.form.startDt = '';
    }

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>